import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { UserTypeaheadComponent } from './user-typeahead.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatAutocompleteModule
    ],
    declarations: [UserTypeaheadComponent],
    exports: [UserTypeaheadComponent]
})
export class UserTypeaheadModule {}
